"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Box = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const styled_tools_1 = require("styled-tools");
const styledProps_1 = require("./styledProps");
const boxTheme = styled_tools_1.theme('Box');
exports.Box = styled_1.default('div') `
  margin: unset;
  padding: unset;
  border: unset;
  background: unset;
  font: unset;
  font-family: inherit;
  font-size: 100%;
  box-sizing: border-box;
  background-color: ${styledProps_1.bgColorWithProps};
  color: ${styledProps_1.textColorWithProps};
  ${boxTheme};
`;

//# sourceMappingURL=Box.js.map
